import {
  WorkOrderTriggerKind,
  WorkOrderTriggerSource,
} from "@redotech/redo-fulfillment-operations-common/work-order-flow/work-order-flow";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const WorkOrderFlowListItem = z.object({
  id: z.string(),
  name: z.string(),
  triggerKind: createEnum(WorkOrderTriggerKind),
  triggerSource: createEnum(WorkOrderTriggerSource).optional(),
  triggerBomIds: z.array(z.string()).optional(),
  triggerBomTags: z.array(z.string()).optional(),
  enabled: z.boolean(),
  index: z.number().int(),
  createdAt: z.string().nullish(),
  updatedAt: z.string().nullish(),
});
export type WorkOrderFlowListItem = z.infer<typeof WorkOrderFlowListItem>;

export const getWorkOrderFlows = {
  name: "getWorkOrderFlows" as const,
  input: z.object({}),
  output: z.object({ flows: z.array(WorkOrderFlowListItem) }),
};
